require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./imperfection-is-beauty-3.json") })
        }
      }, "path---imperfection-is-beauty-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---imperfection-is-beauty-3!./.cache/json/imperfection-is-beauty-3.json
// module id = 837
// module chunks = 231608221292675